import { UserSession, UserSkinProfile } from '../../types';

/**
 * Maps UserSession array to UserSkinProfile array
 * Filters out sessions without output_score and sorts by createdAt
 */
export const mapSessionsToProfiles = (sessions: UserSession[]): UserSkinProfile[] => {
  return sessions
    .filter(session => session.output_score && session.output_score.length > 0)
    .map(session => ({
      _id: session._id,
      name:
        session.first_name && session.last_name
          ? `${session.first_name} ${session.last_name}`.trim()
          : session.guest_name || 'User',
      email: session.email || '',
      age_range: session.age_range || '',
      gender: session.gender || '',
      createdAt: session.createdAt || new Date().toISOString(),
      input_image_url: session.input_image_url || '',
      output_score: session.output_score,
      user_id: session.user_id,
      is_anonymous: session.is_anonymous,
      cs_phone_number: session.cs_phone_number || '',
      annotations: session.annotations || {},
      guest_email: session.guest_email || '',
    }))
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
};

/**
 * Adds annotations from response data to sessions if they don't have them
 */
export const enrichSessionsWithAnnotations = (
  sessions: UserSession[],
  responseAnnotations: Record<string, string> | null
): UserSession[] => {
  if (!responseAnnotations || sessions.length === 0) {
    return sessions;
  }

  return sessions.map(session => {
    if (!session.annotations || Object.keys(session.annotations).length === 0) {
      return { ...session, annotations: responseAnnotations };
    }
    return session;
  });
};

